import React from "react";
import PropTypes from "prop-types";

/**
 * @param {RadioButton.propTypes} props
 */
export const RadioButton = (props) => {
	return (
		<div className="flex items-start">
			<div
				className={[
					"w-3 h-3 border-2 border-solid overflow-hidden rounded-full cursor-pointer flex items-center justify-center flex-col",
					"border-" + props.color,
				].join(" ")}
				onClick={() => {
					// No need to call the onCheck if its already checked.
					if (!props.isChecked) {
						props.onCheck();
					}
				}}
			>
				<div
					className={[
						"w-2 h-2 rounded-full",
						props.isChecked ? "bg-" + props.color : "",
					].join(" ")}
				></div>
			</div>
			{props.label && (
				<div className="text-sm leading-4 ml-2">{props.label}</div>
			)}
			{props.subTitle && (
				<div className="text-xs truncate leading-4 ml-2">
					{props.subTitle}
				</div>
			)}
		</div>
	);
};

RadioButton.defaultProps = {
	label: "",
	subTitle: "",
	onCheck: () => {},
	isChecked: false,
	color: "black",
};

RadioButton.propTypes = {
	isChecked: PropTypes.bool,
	onCheck: PropTypes.func,
	label: PropTypes.string,
	subTitle: PropTypes.string,
	/**
	 * Available options: plugin-1, plugin-2, plugin-3
	 */
	color: PropTypes.string,
};
